(function () {
  'use strict';

  if (window.WagmadeTheme) {
    window.WagmadeTheme.destroy(document);
  }

  var definitions = new Map();
  var instances = new Map();
  var mainRefreshFrame = null;

  function rootsFor(scope, selector) {
    var roots = [];
    if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
    if (scope.querySelectorAll) roots.push.apply(roots, scope.querySelectorAll(selector));
    return roots;
  }

  function register(name, selector, factory) {
    definitions.set(name, { selector: selector, factory: factory });
  }

  function init(scope, refreshExisting) {
    var target = scope || document;

    definitions.forEach(function (definition, name) {
      rootsFor(target, definition.selector).forEach(function (root) {
        var record = instances.get(root) || new Map();
        var current = record.get(name);

        if (current && !refreshExisting) return;
        var instance = current;
        try {
          if (current) {
            if (typeof current.refresh === 'function') current.refresh();
            return;
          }
          instance = definition.factory(root) || {};
          if (typeof instance.init === 'function') instance.init();
          record.set(name, instance);
          instances.set(root, record);
        } catch (error) {
          // A failed optional section must not prevent navigation/commerce startup.
          try { if (instance && typeof instance.destroy === 'function') instance.destroy(); } catch (_) {}
          record.delete(name);
          if (!record.size) instances.delete(root);
          console.warn('[Wagmade] Section initialization failed: ' + name, error);
        }
      });
    });

    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
  }

  function refresh(scope) {
    init(scope || document, true);
  }

  function destroy(scope) {
    var target = scope || document;

    Array.from(instances.entries()).forEach(function (entry) {
      var root = entry[0];
      var record = entry[1];
      var isTarget = target === document || root === target || (target.contains && target.contains(root));
      if (!isTarget) return;

      record.forEach(function (instance) {
        try { if (typeof instance.destroy === 'function') instance.destroy(); } catch (error) {
          console.warn('[Wagmade] Section cleanup failed', error);
        }
      });
      instances.delete(root);
    });
  }

  function handleSectionLoad(event) {
    init(event.target);
    var mainContent = document.querySelector('#MainContent');
    if (mainContent) refresh(mainContent);
  }

  function handleSectionUnload(event) {
    destroy(event.target);
    // Unload can fire before removal. Rebuild shared state on the next frame.
    if (mainRefreshFrame !== null) return;
    var schedule = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 0); };
    mainRefreshFrame = schedule(function () {
      mainRefreshFrame = null;
      var mainContent = document.querySelector('#MainContent');
      if (mainContent) refresh(mainContent);
    });
  }

  function handleSectionReorder() {
    refresh(document);
  }

  function handleBlockSelect(event) {
    refresh(event.target.closest('.shopify-section') || event.target);
    if (event.target.scrollIntoView) {
      event.target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    }
  }

  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);
  document.addEventListener('shopify:section:reorder', handleSectionReorder);
  document.addEventListener('shopify:block:select', handleBlockSelect);

  window.WagmadeTheme = {
    register: register,
    init: init,
    refresh: refresh,
    destroy: destroy,
    designMode: Boolean(window.Shopify && window.Shopify.designMode),
  };
})();
